<template>
  <div>
    <div class="item">
				<span class="icon">
					<img src="../views/images/login/email.png" alt="">
				</span>
      <input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('register.email')">
    </div>
    <!-- <div class="item">
      <span class="icon">
        <img src="../images/login/p1.png" alt="">
      </span>
      <input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
    </div> -->
    <div class="item">
				<span class="icon">
					<img src="../views/images/login/lock.png" alt="">
				</span>
      <input v-model.trim="data.password" :type="inputtype" class="inp" :placeholder="$t('register.password')">
      <div class="eye_bi" :class="inputtype == 'text' ? 'eye' : ''" @click="showPwd" />
    </div>
    <div class="item">
				<span class="icon">
					<img src="../views/images/login/lock.png" alt="">
				</span>
      <input v-model.trim="data.spassword" :type="inputtype" class="inp"
             :placeholder="$t('register.spassword')">
      <div class="eye_bi" :class="inputtype == 'text' ? 'eye' : ''" @click="showPwd" />
    </div>

    <!-- 			<div class="item">
      <input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密�? />
    </div>
    <div class="item">
      <input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密�? />
    </div> -->
    <div v-if="show_sms > 0" class="item">
      <input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
      <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
        <template v-slot="timeData">
						<span @click="sendcode">{{
                timeData.seconds > 0
                    ? timeData.seconds
                    : $t('register.sendCode')
              }}</span>
        </template>
      </van-count-down>
    </div>
<!--非代理链�?   -->
    <template v-if="data.agent==10000">
      <div class="item">
					<span class="icon">
						<img src="../views/images/login/p2.png" class="people" alt="">
					</span>
        <input v-model.trim="data.t_mobile" type="text" class="inp"
               :placeholder="$t('register.referralCode')">
      </div>
    </template>

  </div>

</template>

<script>

export default {
  name: "usertype",
  props:{
    show_sms:{
      default:0,
      type:Number
    },
    time:{
      default:0,
      type:Number
    },
    agent:{
      default:'10000',
      type:String
    }
  },
  data(){
    return{
      inputtype: "password",
      data: {
        password: "",
        spassword: "",
        mobile: "",
        t_mobile: "",
        code: "",
        agent: '10000'
      }
    }
  },
  mounted() {
    this.data.agent = this.agent;
    this.data.t_mobile = this.$router.history.current.query.m;

  },
  methods:{
    showPwd() {
      if (this.inputtype == "password") {
        this.inputtype = "text";
      } else {
        this.inputtype = "password";
      }
    },
    sendcode(){
      this.$emit('sendcode')
    },
    timeCall(){
      this.$emit('timeCall')
    },
    getdata(){
      return this.data;
    }
  },
  watch:{
    'agent'(){
      this.data.agent = this.agent;
    },
    'data.mobile'(){
      this.$emit('change');
    },'data.password'(){
      this.$emit('change');
    },'data.spassword'(){
      this.$emit('change');
    },'data.t_mobile'(){
      this.$emit('change');
    },'data.code'(){
      this.$emit('change');
    }
  }
}
</script>

<style scoped  lang="less">
.mt {
  margin-top: 20px;
}

.item {
  height: 68px;
  border-bottom: 1px solid #f0f1f3;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;

.icon {
  width: 32px;
  height: 27px;

img {
  width: 100%;
  height: 100%;
}
}

input {
  height: 20px;
  margin-left: 7px;
  flex: 1;
  margin-bottom: 3px;
}
}
</style>
